import * as remoteAction from "../remoteAction";
import get from "lodash/get";
import { store } from "../../store";
import { StoreState } from "../../reducers";
import {
  getCampaignId,
  getMerchantId,
  getScreenName,
  getWidgetConfig,
  getWidgetConfigId,
  getWidgetData,
} from "../../reducers/methods";

export type TrackEventActionSuccess = remoteAction.MerchantRemoteResponse<
  "EVENT_SUCCESS",
  any
>;
export type TrackEventActionFailure = remoteAction.MerchantRemoteResponse<
  "EVENT_FAILURE",
  any
>;
export type TrackEventActionRequest = remoteAction.MerchantRemoteResponse<
  "EVENT_REQUEST",
  any
>;

export interface TrackEventAction extends remoteAction.PostRemoteRequest {
  types: {
    request: "EVENT_REQUEST";
    success: "EVENT_SUCCESS";
    failure: "EVENT_FAILURE";
  };
}

export interface TrackEventParams {
  type: string;
  // tslint:disable-next-line:no-any
  [prop: string]: any;
}

// tslint:disable-next-line: cyclomatic-complexity
export const trackEvent = ({
  type,
  ...payload
}: TrackEventParams): TrackEventAction => {
  const state = store.getState() as StoreState;
  const screenName = get(
    getWidgetConfig(state)[getScreenName(state)],
    "label",
    "N/A"
  );
  const customerEmail = get(getWidgetData(state), "customer.email");

  const basePayload = {
    customerEmail: customerEmail || "",
    campaignId: payload.campaignId || getCampaignId(state),
    merchantId: payload.merchantId || getMerchantId(state),
    screenId: getScreenName(state),
    widgetConfigId: payload.widgetConfigId || getWidgetConfigId(state),
  };

  return {
    type: "MERCHANT_REMOTE_REQUEST",
    types: {
      request: "EVENT_REQUEST",
      failure: "EVENT_FAILURE",
      success: "EVENT_SUCCESS",
    },
    method: "POST",
    https: true,
    data: {
      type: type || payload.name,
      payload: {
        screenName,
        ...basePayload,
        ...payload,
      },
      ...basePayload,
    },
    url: `/events/${payload.merchantId || getMerchantId(state)}/track`,
  };
};
